exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    background: url(http://mymaplist.com/img/parallax/back.png);\r\n\tbackground-color: #444;\r\n    background: url(http://mymaplist.com/img/parallax/pinlayer2.png),url(http://mymaplist.com/img/parallax/pinlayer1.png),url(http://mymaplist.com/img/parallax/back.png);    \r\n}\r\n\r\n.vertical-offset-100 {\r\n    padding-top:100px;\r\n}\r\n\r\n.panel-title {\r\n    text-align:center;\r\n}\r\n\r\n.login-help {\r\n    padding-top:10px;\r\n    text-align:center;\r\n}\r\n\r\n.btn-success {\r\n    color: #fff;\r\n    background-color: #337ab7;\r\n    border-color: #2e6da4;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = 1